import React from "react";
import NewsHero from "../sections/NewsHero";
import NewsSection from "../sections/NewsSection";
import Contact from "../sections/Contact";

const News = () => {
  return (
    <div>
      <NewsHero />
      <NewsSection />
      <Contact />
    </div>
  );
};

export default News;
